import '@assets/css/gosky-icons.css';
import 'normalize.css';

import { ApolloProvider } from '@apollo/client';
import globalTheme, { GlobalStyle } from '@assets/theme/global';
import { client } from '@graphql/client';
import { Routes } from '@routes';
import { FunctionComponent, Suspense } from 'react';
import { useThemeSwitcher } from 'react-css-theme-switcher';
import { BrowserRouter } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import { ThemeProvider } from 'styled-components';
import { Tooltip } from '@components/Tooltip';
import { NotificationContainer } from '@components/Notification';

const App: FunctionComponent = () => {
  const { status } = useThemeSwitcher();

  if (status !== 'loaded') return null;

  return (
    <ApolloProvider client={client}>
      <GlobalStyle theme={globalTheme} />
      <ThemeProvider theme={globalTheme}>
        <BrowserRouter>
          <Suspense fallback={<>loading...</>}>
            <Routes />
          </Suspense>
        </BrowserRouter>
      </ThemeProvider>
      <Tooltip
        place="top"
        effect="solid"
        delayHide={1000}
        afterShow={() => setTimeout(ReactTooltip.hide, 3000)}
      />
      <NotificationContainer />
    </ApolloProvider>
  );
};

export default App;
